export class CoreVm {
        DatabaseID: number;
        OrganizationID: number;
        UserID: string;
        PageIndex:number;
        PageSize:number;
        FolderId:number;
        transactionID:number=0;
        subFolderID:number;
        searchKey:string;
        coreID:number;
        TaskID:number;
        userContactID: number;
        RoleIDList:any=[];
        fieldID: number=0;
        requestFrom: number=0;
        officeID:number=0;
        OfficeIDList: any;
        thirdPartyApiID:number=0;
        officeThirdPartyApiID:number=0;
        isArchived:boolean;
        isKanbanView:boolean=false;
}

export class AddCoreVm {
        UserID: string;
        DatabaseID: number;
        OrganizationID: number;
        TransactionID:string;
        CoreID:number;
        TaskID:number;
        Fields:Fields[];  
        FolderID:number;    
        ImageUrl:string; 
        TypeID:number;
        Tags: string;
        parentID:number;
        ContactId:number;
        CompanyId:number;
        officeID:number=0;
        OfficeIDList:[];
        Status:string
}
export class AddContactVm {
        UserID: string;
        DatabaseID: number;
        OrganizationID: number;
        TransactionID:string;
        ContactID:number;
        Fields:Fields[];  
        FolderID:number;    
        ImageUrl:string; 
        TypeID:number;
        Tags: string;
        coreID: number;
        isShared: boolean;
        parentID:number;
        ContactId:number;
        CompanyId:number;
        formFolderID:number;
        formIDSendToAPI: number;
        formID: number;
        officeID:number=0;
        OfficeIDList:[];
        fileManagerItemID:number=0;
        Status:string="";
}
export class AddCompanyVm {
        UserID: string;
        DatabaseID: number;
        OrganizationID: number;
        TransactionID:string;
        CompanyID:number;
        Fields:Fields[];  
        FolderID:number;    
        ImageUrl:string; 
        TypeID:number;
        Tags: string;
        parentID:number;
        ContactId:number;
        CompanyId:number;
        officeID:number=0;
        OfficeIDList:[];
        Status:string="";
}
export class ReorderColumnCoreVm {
        UserID: string;
        FieldID:number;
        PreviousPosition:number;
        CurrentPosition:number;
        FolderID:number;
        OrganizationID: number;
        DatabaseID: number;     
        officeID:number=0;
        OfficeIDList:[];
}


export class UpdateColumnCoreVm {
        UserID: string;
        DatabaseID: number;
        OrganizationID: number;       
        CustomizationGridUserSetting:CustomizationGridUserSetting[];     
        officeID:number=0;
        OfficeIDList:[];  
}
export class Fields{
        FieldID:number;
        FieldName:string;
        FieldValue:string="";           
    }

    export class TicketFields{
        FieldID:number;
        FieldName:string;
        FieldValue:string;           
    }

    export class CustomizationGridUserSetting{
        FieldID:number;
        FolderID:number;
        IsDisplay:boolean;    
        ViewOrder:number;       
    }

    export class FileModelVM{
        UserID: string;
        DatabaseID: number;
        OrganizationID: number;
        Base64String:string; 
        FileName:string; 
        FileExtention:string;   
    }


    export class CreateFilterVm {
        userID: string;
        organizationID: number;
        databaseID: number;
        filterName:string;
        folderID:number;
        isDefault:boolean;
        isFavourite:boolean; 
        officeID:number;  
        filterFieldsRequestModels:filterFieldsRequestModels[];
}

export class filterFieldsRequestModels{
        filterValue:string;
        childFieldType:number;
        fieldID:any;    
        fieldTypeID:number;  
        organizationID:number;     
    }

    export class FilteredCoreVm {
        PageIndex:number;
        PageSize:number;
        UserID: string;
        FolderId:number;
        DatabaseID: number;
        OrganizationID: number;
        fields:fields[];
        userContactID: number;
        roleIDList:any=[];
        officeIDList: any=[];
        officeID:number=0;
}

export class fields{
        filterFieldID:number;
        filterFieldValue:string;
        childFieldType:any;     
    }


    export class AddTicketTaskVm {
        title:string;
        description:string;
        status:number;
        colourCode:string;
        isInternal:boolean;
        taskListID:number;
        dueDate: any;
        startDate:any;
        //customFields:any;
        customFields:Fields[];  
        taskTypeID:number;
        addByEmail:string;
        addByName:string
        userID: string;
        databaseID: number;
        organizationID: number;
        // TransactionID:string;
        // CoreID:number;
        // TaskID:number;
        // Fields:Fields[];  
        // FolderID:number;    
        // ImageUrl:string; 
        // TypeID:number;
        // Tags: string;
        // parentID:number;
        // ContactId:number;
        // CompanyId:number;
         officeID:number=0;
        // OfficeIDList:[];
        // Status:string
}

